/**
 * FRIEND LUV / ROMANTIC LUV (SAVED! FIND step) — separate from Computer match / Community match toggles.
 * Icons use `friendLuv` / `romanticLuv` when set; legacy posters infer from feed + private flags.
 */
export function posterFindLuvIconFlags(poster) {
  if (!poster || typeof poster !== 'object') return { friend: false, romantic: false };
  const friend =
    poster.friendLuv === true ||
    (poster.friendLuv == null && !!(poster.postedToFeed && poster.feedAdId));
  const romantic =
    poster.romanticLuv === true ||
    (poster.romanticLuv == null && !!poster.isPrivateCollage);
  return { friend, romantic };
}

/** Feed ad + optional owning saved poster (same user). */
export function feedAdFindLuvIconFlags(ad, localPoster) {
  const friendLuv =
    typeof ad?.friendLuv === 'boolean' ? ad.friendLuv : localPoster?.friendLuv;
  const romanticLuv =
    typeof ad?.romanticLuv === 'boolean' ? ad.romanticLuv : localPoster?.romanticLuv;
  return posterFindLuvIconFlags({
    friendLuv,
    romanticLuv,
    postedToFeed: true,
    feedAdId: ad?.id,
    isPrivateCollage: ad?.alsoPrivateMatch ?? localPoster?.isPrivateCollage,
  });
}
